module.exports = __webpack_public_path__ + "img/emoji-neutral-on.0c9aefbd.svg";